import React from "react";
import {
  IconKey,
  IconExternalLink,
  IconSchool,
  IconAlertTriangle,
  IconCreditCard,
} from "@tabler/icons-react";

// ===============================================
// API KEY STEP - Step 2 do Onboarding
// Explica a necessidade da API Key da OpenAI
// ===============================================

const SETUP_STEPS = [
  {
    number: "1",
    icon: IconKey,
    title: "Crie sua API Key na OpenAI",
    desc: "Acesse o painel da OpenAI e gere uma nova chave de API",
  },
  {
    number: "2",
    icon: IconCreditCard,
    title: "Insira créditos na OpenAI",
    desc: "Adicione saldo para que a API funcione corretamente",
  },
  {
    number: "3",
    icon: IconExternalLink,
    title: "Configure na plataforma",
    desc: "Cole a API Key nas Configurações Globais da plataforma",
  },
];

const ApiKeyStep = () => {
  return (
    <>
      <div className="onb-card__header onb-card__header--with-icon">
        <div className="onb-card__icon onb-card__icon--warning">
          <IconKey size={28} />
        </div>
        <h2 className="onb-card__title">API Key da OpenAI</h2>
        <p className="onb-card__subtitle">
          Passo essencial antes de usar a plataforma
        </p>
      </div>

      <div className="onb-card__body">
        <p className="onb-card__text">
          Para utilizar os <strong>agentes de IA</strong> e diversas
          funcionalidades da plataforma, você precisa criar e configurar
          uma <strong>API Key da OpenAI</strong>. Ela é necessária tanto
          no <strong>Criador 1.0</strong> quanto no <strong>Criador 2.0</strong>.
        </p>

        {/* Passos para configurar */}
        <div className="onb-menu-list">
          {SETUP_STEPS.map((item, index) => (
            <div key={index} className="onb-menu-item">
              <div className="onb-menu-item__icon" style={{
                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
              }}>
                <span style={{ fontWeight: 800, fontSize: '0.875rem', color: '#fff' }}>
                  {item.number}
                </span>
              </div>
              <div className="onb-menu-item__info">
                <span className="onb-menu-item__name">{item.title}</span>
                <span className="onb-menu-item__desc">{item.desc}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Link direto para criar a API Key */}
        <a
          href="https://platform.openai.com/settings/organization/api-keys"
          target="_blank"
          rel="noopener noreferrer"
          className="onb-link-cta"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            padding: '12px 20px',
            borderRadius: '12px',
            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
            color: '#fff',
            fontWeight: 600,
            fontSize: '0.875rem',
            textDecoration: 'none',
            marginTop: '16px',
            transition: 'all 0.2s ease',
          }}
        >
          <IconExternalLink size={18} />
          Criar API Key na OpenAI
        </a>

        {/* Warning */}
        <div className="onb-highlight" style={{ marginTop: '16px' }}>
          <IconAlertTriangle size={18} className="onb-highlight__icon" />
          <span className="onb-highlight__text">
            <strong>Sem a API Key</strong>, a criação de agentes e o
            treinamento RAG não funcionarão. Esta é a primeira coisa
            que você deve fazer.
          </span>
        </div>

        {/* Link para aulas */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '10px 14px',
          borderRadius: '10px',
          background: 'rgba(59, 130, 246, 0.08)',
          marginTop: '12px',
          fontSize: '0.8125rem',
          color: 'var(--text-secondary, #475569)',
        }}>
          <IconSchool size={18} style={{ color: '#3b82f6', flexShrink: 0 }} />
          <span>
            Não sabe como criar? Temos uma <strong>aula passo a passo</strong> no
            menu <strong>Aprendizado</strong>.
          </span>
        </div>
      </div>
    </>
  );
};

export default ApiKeyStep;
